"use client";

import React, { useState } from "react";
import SectionHeader from "@/components/SectionHeader";
import Icon from "@/components/ui/Icon";
import { blogFaqs as faqs } from "@/data/faqData";

export default function FaqSection() {
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null);

  const handleFaqToggle = (index: number) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };

  return (
    <section className="py-section-gap px-margin-mobile md:px-gutter max-w-container-max mx-auto">
      <SectionHeader
        title="Client Insights &amp; FAQ"
        subtitle="Common inquiries regarding our engagement models and technical execution."
        center={true}
      />
      
      <div className="max-w-3xl mx-auto space-y-4 mt-16">
        {faqs.map((faq, index) => {
          const isOpen = openFaqIndex === index;
          return (
            <div key={index} className="border-b border-surface-variant overflow-hidden">
              <button 
                onClick={() => handleFaqToggle(index)} 
                className="faq-toggle w-full flex justify-between items-center py-6 text-left group focus:outline-none cursor-pointer"
              >
                <span className="text-xl md:text-headline-md text-on-surface group-hover:text-primary transition-colors font-bold">
                  {faq.q}
                </span>
                <Icon 
                  name="expand_more" 
                  size={24} 
                  className={`transition-transform duration-300 ${isOpen ? "rotate-180" : "rotate-0"}`} 
                />
              </button>
              <div 
                className={`faq-content transition-all duration-300 ease-in-out ${isOpen ? "max-h-[200px] opacity-100 pb-8" : "max-h-0 opacity-0"}`}
                style={{ overflow: 'hidden' }}
              >
                <p className="font-body-md text-body-md text-secondary leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
